var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    stroke: "#00567A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2838 27.0061C52.9792 25.9112 51.0258 26.1207 49.9831 27.4673L37.9193 43.0479C36.8208 44.4666 34.7308 44.6102 33.4486 43.3551L28.4743 38.4858C27.3078 37.344 25.4425 37.3443 24.2764 38.4866L24.1877 38.5734C22.9868 39.7498 22.9868 41.6832 24.1877 42.8596L34.2027 52.6702C35.4743 53.9158 37.5445 53.7867 38.6514 52.3927L55.1843 31.5722C56.195 30.2995 56.0084 28.4535 54.7636 27.4087L54.2838 27.0061Z",
    fill: "#00567A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRegister);
export default __webpack_public_path__ + "static/media/checkRegister.0c7c15fa32ed0a7ea6cf7308f3a9a184.svg";
export { ForwardRef as ReactComponent };